module.exports = __webpack_public_path__ + "img/horizontal_2_1_5012.2537c98d.png";